import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APITrangThai = {
  LIST_TRANG_THAI: `${BASE_API_URL_CAP_DIEN}/trang-thai/list`,
  CREATE_TRANG_THAI: `${BASE_API_URL_CAP_DIEN}/trang-thai/create`,
  UPDATE_TRANG_THAI: `${BASE_API_URL_CAP_DIEN}/trang-thai/update`,
  REMOVE_TRANG_THAI: `${BASE_API_URL_CAP_DIEN}/trang-thai/delete`,
};
